import React from 'react';

const UploadImageIcon = () => {
	return (
		<svg
			fill='none'
			height='30'
			viewBox='0 0 30 30'
			width='30'
		>
			<path
				d='M19.6875 11.7188C19.6875 12.0917 19.5393 12.4494 19.2756 12.7131C19.0119 12.9768 18.6542 13.125 18.2812 13.125C17.9083 13.125 17.5506 12.9768 17.2869 12.7131C17.0232 12.4494 16.875 12.0917 16.875 11.7188C16.875 11.3458 17.0232 10.9881 17.2869 10.7244C17.5506 10.4607 17.9083 10.3125 18.2812 10.3125C18.6542 10.3125 19.0119 10.4607 19.2756 10.7244C19.5393 10.9881 19.6875 11.3458 19.6875 11.7188ZM27.1875 6.5625V21.5625V23.4375C27.1875 23.9348 26.99 24.4117 26.6383 24.7633C26.2867 25.115 25.8098 25.3125 25.3125 25.3125H4.6875C4.19022 25.3125 3.71331 25.115 3.36167 24.7633C3.01004 24.4117 2.8125 23.9348 2.8125 23.4375V19.6875V6.5625C2.8125 6.06522 3.01004 5.58831 3.36167 5.23667C3.71331 4.88504 4.19022 4.6875 4.6875 4.6875H25.3125C25.8098 4.6875 26.2867 4.88504 26.6383 5.23667C26.99 5.58831 27.1875 6.06522 27.1875 6.5625ZM25.3125 19.3008V6.5625H4.6875V17.4258L8.98828 13.125C9.34127 12.7772 9.81694 12.5822 10.3125 12.5822C10.8081 12.5822 11.2837 12.7772 11.6367 13.125L16.875 18.3633L19.3008 15.9375C19.6538 15.5897 20.1294 15.3947 20.625 15.3947C21.1206 15.3947 21.5962 15.5897 21.9492 15.9375L25.3125 19.3008Z'
				fill='#4D4DB3'
			/>
		</svg>
	);
};

export default UploadImageIcon;
